import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ExchangeRatesRequest } from './exchange-rates-requset';

export class ExchangeRatesResponseModel extends GlobalResponseObject{
    data?: ExchangeRatesRequest[]

    constructor(status: boolean, intlCode: number, internalMessage: string, data?: ExchangeRatesRequest[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
}
}
